export enum APP_DISCLAIMER_TYPES {
  primary = 'primary',
  warning = 'warning',
  error = 'error',
}
